<template>
  <div class="">
    <div class="max-w-sm m-auto p-8 bg-white mt-12 rounded">

      <div class="text-center">
        <img src="https://img.icons8.com/dotty/80/000000/cancel.png" class="inline" />
      </div>

      <div class="text-3xl font-thin text-gray-700 text-center mt-6">
        Invalid Link
      </div>

      <div class="mt-6 leading-normal text-base">
        Your link is either expired or invalid. Please contact your broker
        so that a new link can be provided.
      </div>
    </div>

    <!-- <div class="max-w-sm m-auto pl-8 mt-6">
      <PublicFooter theme="dark"></PublicFooter>
    </div> -->
  </div>
</template>

<script>
  export default {
    created() {
      document.body.className = 'blue-bg';
    },

    destroyed() {
      document.body.className = '';
    },
  }
</script>